import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskNavigationTabsComponent } from './task-navigation-tabs/task-navigation-tabs.component';
import { TaskToCompleteContainerComponent } from './task-to-complete-container/task-to-complete-container.component';
import { UIRouterModule } from '@uirouter/angular';
import { TaskStates } from '@fi-app/task/task-states';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { TaskCompletedContainerComponent } from './task-completed-container/task-completed-container.component';
import { TaskStatusContainerComponent } from './task-status-container/task-status-container.component';
import { TaskEditContainerComponent } from './task-edit-container/task-edit-container.component';
import { FiStateSrefModule } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.module';
import { FiTaskSharedModule } from '@fi-shared/fi-task-shared/fi-task-shared.module';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { TaskEditModule } from '@fi-shared/fi-task-shared/task-edit/task-edit.module';
import { TaskListModule } from '@fi-shared/fi-task-shared/task-list/task-list.module';
import { TaskDetailsContainerComponent } from './task-details-container/task-details-container.component';
import { TaskDetailsModule } from '@fi-shared/fi-task-shared/task-details/task-details.module';
import { TasksStatusModule } from '@fi-shared/fi-task-shared/tasks-status/tasks-status.module';
import { TasksArchivedContainerComponent } from '@fi-app/task/tasks-archived-container/tasks-archived-container.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(TaskStates),
        FiTabsModule,
        FiStateSrefModule,
        FiTaskSharedModule,
        ButtonBackModule,
        FiAppTextSharedModule,
        TaskEditModule,
        TaskListModule,
        TaskDetailsModule,
        TasksStatusModule,
        MatIconModule,
        MatButtonModule,
        FiButtonBackNewModule,
    ],
    declarations: [
        TaskNavigationTabsComponent,
        TaskToCompleteContainerComponent,
        TaskCompletedContainerComponent,
        TaskStatusContainerComponent,
        TaskEditContainerComponent,
        TaskDetailsContainerComponent,
        TasksArchivedContainerComponent,
    ],
})
export class TaskModule {}
